import * as React from 'react';
import { Text, View } from 'react-native';

export default class AdMobRewarded extends React.Component<object> {
  render() {
    return (
      <View>
        <Text>AdMobRewarded component not supported on the web</Text>
      </View>
    );
  }
}
